
import SearchProductCarousel from "./SearchProductCarousel";

export default {
  components: { SearchProductCarousel },

  props: {
    products: { type: Array, required: true },
    suggestion: { type: String, required: true },
    closeSearch: { type: Function, required: true },
    withCenterSearch: { type: Boolean, default: false },
  },

  computed: {
    suggestionText() {
      return this.suggestion.length > 50
        ? `${this.suggestion.substring(0, 50)}...`
        : this.suggestion;
    },
    viewAllURL() {
      return this.$router.resolve({
        path: "/products/search",
        query: { query: this.suggestion },
      }).href;
    },
    swiperClass() {
      return `center-search-products-swiper`;
    },
  },
};
